module.exports = __webpack_public_path__ + "static/img/bg-01.27a73a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/bg-01.png
// module id = VuYZ
// module chunks = 64